import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import classnames from 'classnames';
import { useBodyScrollLock } from '@wix/da-ds/pkg/hooks/useBodyScrollLock';
import UserMenuAvatar from './UserMenuAvatar';
import LoggedInUserMenu from './LoggedInUserMenu';
import LoggedOutUserMenu from './LoggedOutUserMenu';
import { useIosHeightHack } from './useIosHeightHack';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './UserMenu.scss';
const UserMenu = (_param)=>{
    var { isOpen, onOpen, currentUser, className } = _param, props = _object_without_properties(_param, [
        "isOpen",
        "onOpen",
        "currentUser",
        "className"
    ]);
    const { isLoggedIn } = useContext(SessionContext);
    const [isUserMenuOpened, setIsUserMenuOpened] = useState(!!isOpen);
    const wasOpen = useRef(false);
    const { onLock, onUnlock, setScrollableRef } = useBodyScrollLock();
    const { isIosHeightHackNeeded, setRootRef } = useIosHeightHack();
    useEffect(()=>{
        const isOpenChanged = wasOpen.current !== isOpen;
        if (isOpenChanged && isUserMenuOpened !== isOpen) {
            setIsUserMenuOpened(!!isOpen);
        }
        wasOpen.current = !!isOpen;
    }, [
        isOpen,
        isUserMenuOpened
    ]);
    const openUserMenu = useCallback(()=>{
        onLock();
        if (onOpen) {
            onOpen();
        }
        setIsUserMenuOpened(true);
    }, [
        onLock,
        onOpen
    ]);
    const closeUserMenu = useCallback(()=>{
        onUnlock();
        setIsUserMenuOpened(false);
    }, [
        onUnlock
    ]);
    const toggleUserMenu = useCallback(()=>isUserMenuOpened ? closeUserMenu() : openUserMenu(), [
        closeUserMenu,
        isUserMenuOpened,
        openUserMenu
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['user-menu-wrapper'], className)
    }, !isUserMenuOpened && /*#__PURE__*/ React.createElement(UserMenuAvatar, {
        currentUser: currentUser,
        onToggleUserMenu: toggleUserMenu,
        isUserMenuOpened: false
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['user-menu-shade'], isUserMenuOpened && s['is-active']),
        // Since react-onclickoutside wasn't really working for this component and my most
        // valiant efforts to make it do so were met with failure, just do it ourselves
        onTouchStart: toggleUserMenu,
        onClick: toggleUserMenu,
        "aria-hidden": !isUserMenuOpened
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['user-menu-list-wrapper'], isUserMenuOpened && s['is-opened'], isIosHeightHackNeeded && s['ios-sucks']),
        ref: (node)=>{
            setScrollableRef(node);
            setRootRef(node);
        },
        "aria-hidden": !isUserMenuOpened
    }, isLoggedIn && currentUser ? /*#__PURE__*/ React.createElement(LoggedInUserMenu, _object_spread({
        currentUser: currentUser,
        isUserMenuOpened: isUserMenuOpened,
        onToggleUserMenu: toggleUserMenu
    }, props)) : /*#__PURE__*/ React.createElement(LoggedOutUserMenu, _object_spread({
        isUserMenuOpened: isUserMenuOpened,
        onToggleUserMenu: toggleUserMenu
    }, props))));
};
UserMenu.displayName = 'UserMenu';
export default UserMenu;
